import { ImageSection } from "../../models/page-builder/image-section.model";

export const MOCK_IMAGE_SECTION: ImageSection = {
  type: "image",
  content: {
    images: [
      {
        buttonText: "Explore",
        buttonLink: "https://itsmekamal.com",
        textColor: "#333",
        backgroundColor: "#009688",
        borderColor: "#0096",
      },
      {
        buttonText: "Get Started",
        buttonLink: "https://onlinecoursehost.com",
        textColor: "#000",
        backgroundColor: "#ff5722",
        borderColor: "#000",
      },
    ],
  },
  design: {
    layout: "card",
    contentAlignment: "leftRight",
    appearance: {
      cardBackgroundColor: "#808080",
      backgroundColor: "#ffffff",
    },
  },
};
